// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const UserActions = registerClientReference(
    function() { throw new Error("Attempted to call UserActions() from the server but UserActions is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/users/_form.tsx",
    "UserActions",
);
export const UsersTable = registerClientReference(
    function() { throw new Error("Attempted to call UsersTable() from the server but UsersTable is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/users/_form.tsx",
    "UsersTable",
);
